/**
 * Configuration utilities for SpeedGauge Chat Client
 */

import type { AppConfig } from '../types';

export const API_BASE_URL = '/api';

/**
 * Get application configuration from environment variables
 */
export const getAppConfig = (): AppConfig => {
  return {
    apiBaseUrl: API_BASE_URL,
    defaultCustomerId: process.env.REACT_APP_DEFAULT_CUSTOMER_ID || '',
    sessionTimeout: parseInt(process.env.REACT_APP_SESSION_TIMEOUT || '3600', 10),
    maxMessageLength: parseInt(process.env.REACT_APP_MAX_MESSAGE_LENGTH || '10000', 10),
    typingIndicatorDelay: parseInt(process.env.REACT_APP_TYPING_INDICATOR_DELAY || '2000', 10),
    apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '120000', 10),
    enableDarkTheme: process.env.REACT_APP_ENABLE_DARK_THEME === 'true',
    enableCitations: process.env.REACT_APP_ENABLE_CITATIONS === 'true',
    debugMode: process.env.REACT_APP_ENABLE_DEBUG_MODE === 'true'
  };
};

/**
 * Check if we're in development mode
 */
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

/**
 * Check if we're in production mode
 */
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};

/**
 * Check if we're in test mode
 */
export const isTest = (): boolean => {
  return process.env.NODE_ENV === 'test';
};

/**
 * Get API base URL for display purposes
 */
export const getDisplayApiUrl = (): string => {
  return getAppConfig().apiBaseUrl;
};
